import React, { useEffect, useRef, useState } from 'react';
import $ from 'jquery';
import Navbar from './Navbar';
import Footer from './Footer';
import { Icon } from '@iconify/react';
import { Star, Sparkles, CheckCircle2, ChevronDown } from 'lucide-react';
import {
  FaWeight,
  FaSmile,
  FaHandHoldingMedical,
  FaChartLine,
  FaBrain,
  FaBookOpen,
  FaShieldAlt,
  FaBolt,
  FaSpa,
  FaHandSparkles,
} from 'react-icons/fa';
import { GiHairStrands } from 'react-icons/gi';
const features = [
  { icon: <FaSpa size={34} />, text: 'Reduces fine lines & wrinkles' },
  { icon: <FaSmile size={34} />, text: 'Promotes a brighter complexion' },
  { icon: <FaHandHoldingMedical size={34} />, text: 'Improves skin firmness & elasticity' },
  { icon: <GiHairStrands size={34} />, text: 'Thickens & strengthens hair' },
  { icon: <FaChartLine size={34} />, text: 'Increases skin hydration & moisture' },
  { icon: <FaHandSparkles size={34} />, text: 'Supports nail strength & growth' },
];
  const reviewsData = [
    {
      id: 1,
      name: 'Riddhi',
      verified: true,
      rating: 5,
      comment:
        'I first saw the product on Instagram and bought it impulsively, zero regrets. After my first cup, I was a bit overwhelmed by the emotions...',
      timeAgo: '1 year ago',
      images: ['/images/review1-1.jpg', '/images/review1-2.jpg'],
    },
    {
      id: 2,
      name: 'Ishaan Shirsat',
      verified: true,
      rating: 5,
      comment: 'This product changed my mornings completely. Highly recommend!',
      timeAgo: '6 months ago',
      images: [],
    },
  ];

const Collagen = () => {
  const autoplayRef = useRef(null);
  const [selectedPack, setSelectedPack] = useState('sachet');
  const [selectedSize, setSelectedSize] = useState('small');
  const [isExpanded, setIsExpanded] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [activeFlavor, setActiveFlavor] = useState('Pink Guava');
  const [activePack, setActivePack] = useState('5');
  const [selectedTag, setSelectedTag] = useState(null);
  const [qty, setQty] = useState(1);
  const [activeMain, setActiveMain] = useState(null);
  const [openIndex, setOpenIndex] = useState(null);
  const [activeFaq, setActiveFaq] = useState(null);
  const [showSummary, setShowSummary] = useState(false);
  const [selectedFlavour, setSelectedFlavour] = useState('');
  const totalStars = 5;
  const [activeIndex, setActiveIndex] = useState(null);
  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };
  const [showForm, setShowForm] = useState(false);
  const [expanded, setExpanded] = useState(null);

  const [reviewText, setReviewText] = useState('');
  const [rating, setRating] = useState(0);
  const [reviews, setReviews] = useState(reviewsData);

  const handleSubmitReview = () => {
    if (!reviewText || rating === 0) return;

    const newReview = {
      id: Date.now(),
      name: 'You',
      verified: false,
      rating,
      comment: reviewText,
      timeAgo: 'Just now',
      images: [],
    };

    setReviews([newReview, ...reviews]);
    setReviewText('');
    setRating(0);
    setShowForm(false);
  };
  const flavours = [
    {
      id: 1,
      name: 'Blueberry Glow',
      img: '/assets/images/Collagen.png',
      popular: true,
    },
  ];
  const toggleFaq = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };


  const toggleMain = (index) => {
    setActiveMain(activeMain === index ? null : index);
    setIsExpanded(false);
    setOpenIndex(null);
  };
  const faqs = [
    {
      question: 'What is Evercore Advanced Collagen Peptides?',
      answer:
        'A daily marine collagen blend with 8g Japanese Marine Collagen plus Vitamin C, antioxidants, Hyaluronic Acid and Biotin — to support skin, joints, hair and nails.',
    },
    {
      question: 'How does collagen work?',
      answer:
        'Hydrolysed collagen is broken into small peptides the body can use as building blocks to support its natural collagen processes.',
    },
    {
      question: 'When will I see results?',
      answer: 'Most people notice subtle changes in 8–12 weeks with daily, consistent use.',
    },
    {
      question: 'How do I take it?',
      answer: 'Mix 1 scoop into water, juice or smoothies — anytime you’ll remember every day.',
    },
    {
      question: 'Can I take it daily?',
      answer: 'Yes — collagen works best when taken consistently.',
    },
    {
      question: 'Is it vegetarian or vegan?',
      answer: 'No — it’s marine collagen (fish-derived). Plants don’t contain real collagen.',
    },
    {
      question: 'Does it taste fishy?',
      answer: 'No — the Blueberry Glow flavour is light, clean and smooth.',
    },
    {
      question: 'Does it help with skin?',
      answer: 'It supports firmness, elasticity and hydration from within — as part of a routine.',
    },
    {
      question: 'Does it help with joints?',
      answer: 'Collagen supports connective tissue structure and may help joint comfort over time.',
    },
    {
      question: 'Can I use it with whey or other supplements?',
      answer: 'Yes — they work differently. Space doses and stay hydrated.',
    },
    {
      question: 'Does it have sugar?',
      answer: 'No added sugar — gently sweetened with monk fruit.',
    },
    {
      question: 'Is it safe for medical conditions?',
      answer: 'Check with your doctor if pregnant, nursing, under 18, or on medication.',
    },
    {
      question: 'Can men take collagen?',
      answer: 'Yes — collagen supports skin, joints and tissue health for everyone.',
    },
    {
      question: 'Do I need to cycle it?',
      answer: 'No — daily, long-term consistency works best.',
    },
    {
      question: 'Will it make me gain weight?',
      answer: 'No — it’s low-calorie. Weight changes depend on overall diet and lifestyle.',
    },
    {
      question: 'Any side effects?',
      answer:
        'Generally well tolerated. If sensitive, start with half a scoop and increase slowly.',
    },
    {
      question: 'Is it quality tested?',
      answer: 'Manufactured under controlled standards and batch-tested before release.',
    },
  ];
  const productData = {
    'Product Name': 'Vegan Collagen ',
    Ingredient:
      'Hydrolysed Marine Collagen Peptide,L-Ascorbic Acid, D-Alpha Tocopheryl Acetate,Zinc Gluconate, Grape Seed Extract,D-Biotin, Sodium Selenite, L-Glutathione,Hyaluronic Acid, Sodium Chloride,Acidity Regulator (INS 330),Monk Fruit Juice Concentrate,Nature Identical Flavouring Substances – Blueberry Flavour,Anticaking Agent (INS 551),Permitted Food Color (INS 133).',
    MRP: '2899 (incl. of all taxes)',
    Barcode: '743966049187',
    // Dimensions: '11 x 9 x 9 cm',
    Weight: '300 g',
    'Shelf Life': '18 months',
    'Country Of Origin': 'India',
    'Marketer Details With FSSAI Logo & License No.':
      'Ward No. 11, Behind BR 45 Restaurant,Kachahari Road, Bhabua (Kaimur),Bihar – 821101 FSSAI LIC. NO.: 10425999000324',
    'Manufacturer Details With FSSAI Logo & License No.':
      'NUTRO LIFE SCIENCE Indl Plot No. D-173 Gf At Phase 8B Indl Focal Point, Mohali, Punjab – 160055 FSSAI LIC. NO.: 12122999000378',
  };
  const [showMore, setShowMore] = useState(false);
  const toggleShowMore = () => setShowMore(!showMore);
  const increaseQty = () => {
    setQty((prev) => prev + 1);
  };

  const decreaseQty = () => {
    setQty((prev) => (prev > 1 ? prev - 1 : 1));
  };
  const certifications = [
    { img: '/assets/images/fda.png', alt: 'FDA' },
    { img: '/assets/images/Haccp.webp', alt: 'HACCP' },
    { img: '/assets/images/gmp_converted.webp', alt: 'GMP' },
    { img: '/assets/images/iso_converted.webp', alt: 'ISO' },
    { img: '/assets/images/fssai.jpg', alt: 'FSSAI' },
    { img: '/assets/images/non-gmo.jpg', alt: 'Non GMO' },
  ];
  useEffect(() => {
    if (showModal) {
      document.body.classList.add('modal-open');
      document.body.style.overflow = 'hidden';
    } else {
      document.body.classList.remove('modal-open');
      document.body.style.overflow = '';
    }

    return () => {
      document.body.classList.remove('modal-open');
      document.body.style.overflow = '';
    };
  }, [showModal]);

  useEffect(() => {
    /**=====================
            Quantity 2 js
        ==========================**/
    $('.addcart-button').click(function () {
      $(this).next().addClass('open');
      $('.add-to-cart-box .qty-input').val('1');
    });

    $('.qty-left-minus').on('click', function () {
      var $qty = $(this).siblings('.qty-input');
      var _val = $($qty).val();
      if (_val === '1') {
        var _removeCls = $(this).parents('.cart_qty');
        $(_removeCls).removeClass('open');
      }
      var currentVal = parseInt($qty.val());
      if (!isNaN(currentVal) && currentVal > 0) {
        $qty.val(currentVal - 1);
      }
    });

    $('.qty-right-plus').click(function () {
      if ($(this).prev().val() < 9) {
        $(this)
          .prev()
          .val(+$(this).prev().val() + 1);
      }
    });
  }, []);
  const ingredients = [
    {
      name: 'Japanese Marine Collagen',
      description: 'Supports firmness & elasticity',
      img: '/assets/images/Japanese_Marine_Collagen.webp',
    },
    {
      name: '✨ L-Glutathione ',
      description: 'Radiance & clarity support',
      img: '/assets/images/L-Glutathione.webp',
    },
    {
      name: '🍊 Vitamin C',
      description: 'Boosts natural collagen formation',
      img: '/assets/images/Vitamin_C.webp',
    },
    {
      name: '🌿 Grape Seed Extract',
      description: 'Powerful plant antioxidants',
      img: '/assets/images/Grape_Seed_Extract.webp',
    },

    {
      name: '💧 Hyaluronic Acid',
      description: 'Hydration + plumpness support',
      img: '/assets/images/Hyaluronic_Acid.webp',
    },
  ];

  const data = [
    { brand: 'Taste' },
    { brand: 'Effectiveness' },
    { brand: 'Collagen per Scoop' },
    { brand: 'Antioxidant Boost' },
    { brand: 'Calories & Protein' },
  ];

  const accordionData = [
    {
      title: 'Nutritional information',
      content: 'Here goes nutritional information details...',
    },
    {
      title: 'Ingredients',
      content: 'Here goes ingredients details...',
    },
    {
      title: 'Why choose Advanced Collagen Peptides?',
      content: 'Reasons to choose advanced collagen peptides...',
    },
    {
      title: 'When to use Advanced Collagen Peptides?',
      content: 'Usage timing details...',
    },
    {
      title: 'Myths About Collagen',
      content: 'Common myths about collagen explained...',
    },
  ];

  return (
    <>
      <Navbar />

      {/* <!-- Product Left Sidebar Start --> */}
      <section className="product-section">
        <div className="container-fluid-lg">
          <div className="row">
            <div className="col-xxl-12 col-xl-12 col-lg-12  wow fadeInUp">
              <div className="row g-4">
                <div className="col-xl-6 wow fadeInUp">
                  <div className="product-left-box">
                    <div className="row g-sm-4 g-2">
                      <div className="col-12">
                        <div className="product-main no-arrow">
                          <div>
                            <div className="slider-image">
                              <img
                                src="/assets/images/Collagen.png"
                                id="img-1"
                                data-zoom-image="/assets/images/Collagen.png"
                                className="img-fluid image_zoom_cls-0 blur-up lazyload"
                                alt="img"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-xl-6 wow fadeInUp">
                  <div className="right-box-contain">
                    <h6 className="offer-top">30% Off</h6>
                    <h2
                      className="name"
                      style={{ fontSize: '20px' }}
                    >
                      Marine Collagen Peptides 300g Jar- Evercore Advanced Japanese Marine Collagen
                      Peptides | 8g Per Serving | Skin Hair Joints | 300g
                    </h2>

                    <div className="price-rating">
                      <h3 className="theme-color price">
                        ₹2499<del className="text-content">₹2899</del>{' '}
                        <span className="offer theme-color">(8% off)</span>
                        <p className="text-content">23g protein per scoop (33g scoop size).</p>
                      </h3>
                      <div className="product-rating custom-rate">
                        <ul className="rating">
                          <li>
                            <i
                              data-feather="star"
                              className="fill"
                            ></i>
                          </li>
                          <li>
                            <i
                              data-feather="star"
                              className="fill"
                            ></i>
                          </li>
                          <li>
                            <i
                              data-feather="star"
                              className="fill"
                            ></i>
                          </li>
                          <li>
                            <i
                              data-feather="star"
                              className="fill"
                            ></i>
                          </li>
                          <li>
                            <i data-feather="star"></i>
                          </li>
                        </ul>
                        <span className="review">23 Customer Review</span>
                      </div>
                    </div>

                    <div className="mt-4">
                      <svg
                        width="100%"
                        height="70"
                        viewBox="0 0 900 70"
                        preserveAspectRatio="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        {/* Background */}
                        <rect
                          x="0"
                          y="0"
                          width="900"
                          height="70"
                          fill="#FFD35A"
                        />

                        {/* Left Zig-Zag */}
                        <polygon
                          fill="#fff"
                          points="
              0,0 15,7 0,14 15,21 0,28
              15,35 0,42 15,49 0,56 15,63 0,70
            "
                        />

                        {/* Right Zig-Zag */}
                        <polygon
                          fill="#fff"
                          points="
              900,0 885,7 900,14 885,21 900,28
              885,35 900,42 885,49 900,56 885,63 900,70
            "
                        />

                        {/* Lightning Icon */}
                        <text
                          x="40"
                          y="35"
                          fontSize="28"
                          fontWeight="700"
                          fill="#2a2a2a"
                          dominantBaseline="middle"
                          textAnchor="middle"
                        >
                          ⚡
                        </text>

                        {/* Main Text */}
                        <text
                          x="80"
                          y="25"
                          fontSize="16"
                          fontWeight="700"
                          fill="#2a2a2a"
                          fontFamily="Arial, sans-serif"
                        >
                          Use code: NEWYEAR25
                        </text>

                        {/* Sub Text */}
                        <text
                          x="80"
                          y="45"
                          fontSize="14"
                          fill="#2a2a2a"
                          fontFamily="Arial, sans-serif"
                        >
                          Get Flat 15% Off on all orders
                        </text>
                      </svg>
                    </div>

                    <div className="product-package">
                      <div className="product-title">
                        <h4>Pack: </h4>
                      </div>

                      <ul className="rectangle select-package">
                        <li className="form-check">
                          <input
                            className="form-check-input"
                            checked={selectedPack === 'sachet'}
                            type="radio"
                            name="pack"
                            id="sachet"
                            onChange={() => setSelectedPack('sachet')}
                          />
                          <label
                            className={`form-check-label ${selectedPack === 'sachet' ? 'active' : ''}`}
                            htmlFor="sachet"
                          >
                            <span>Jar</span>
                          </label>
                        </li>

                        <li className="form-check">
                          <input
                            className="form-check-input"
                            checked={selectedPack === 'box'}
                            type="radio"
                            name="pack"
                            id="box"
                            onChange={() => setSelectedPack('box')}
                          />
                          <label
                            className={`form-check-label ${selectedPack === 'box' ? 'active' : ''}`}
                            htmlFor="box"
                          >
                            <span>sachet</span>
                          </label>
                        </li>
                      </ul>
                    </div>

                    {/* 👉 Conditional Rendering */}
                    {selectedPack === 'sachet' && (
                      <div className="pack-details">
                        <h5>Jar Details</h5>
                        <p>300 gram Jar</p>
                      </div>
                    )}

                    {selectedPack === 'box' && (
                      <div className="pack-details">
                        <h5>sachet Details</h5>
                        <p>23 gram</p>
                      </div>
                    )}

                    <section>
                      <h3 className="label">Flavours:</h3>
                      <div className="flavour-grid">
                        {flavours.map((f) => (
                          <div
                            key={f.id}
                            className={`flavour-card ${selectedFlavour === f.name ? 'active-flavour' : ''}`}
                            onClick={() => setSelectedFlavour(f.name)}
                          >
                            {f.popular && <span className="popular-badge">Most popular</span>}
                            <div className="img-wrapper">
                              <img
                                src={f.img}
                                alt={f.name}
                              />
                            </div>
                            <p className="flavour-text">{f.name}</p>
                          </div>
                        ))}
                      </div>
                    </section>

                    <div className="fc-bundle-container mt-5">
                      <div className="fc-bundle-header">
                        <h1 className="fc-bundle-title">Focus & Calm Bundle</h1>
                        <span className="fc-bundle-badge">Extra 5% OFF</span>
                        <p className="fc-bundle-subtitle">
                          Curated essentials for better focus & relaxation
                        </p>
                      </div>

                      <div className="fc-bundle-products">
                        <div className="fc-product-card">
                          <img
                            src="assets/images/Collagen.png"
                            alt="Collagen Peptides"
                            className="fc-product-image"
                          />

                          <div className="fc-product-info">
                            <h3 className="fc-product-title">Collagen Peptides</h3>
                            <p className="fc-product-desc">
                              Supports skin, joints & overall wellness
                            </p>
                            <p className="fc-product-price">₹ 2499</p>
                          </div>
                        </div>
                      </div>

                      <div className="fc-bundle-footer">
                        <div className="fc-price-summary">
                          <div className="fc-price-row">
                            <span>Total</span>
                            <span className="fc-old-price">₹ 2899</span>
                          </div>

                          <div className="fc-price-row fc-final-row">
                            <span>Bundle Price</span>
                            <span className="fc-final-price">₹ 2499</span>
                          </div>

                          <p className="fc-save-text">You save ₹ 89 🎉</p>
                        </div>

                        <button className="fc-add-to-cart">ADD TO CART</button>
                      </div>

                      <div className="buy-box">
                        <a href="/Wishlist">
                          <i
                            data-feather="heart"
                            style={{ color: '#000' }}
                          ></i>
                          <span>Add To Wishlist</span>
                        </a>
                      </div>
                    </div>

                    <div className="features-container">
                      <div className="features-grid">
                        {features.map((f, i) => (
                          <div
                            className="feature-item"
                            key={i}
                          >
                            <div className="icon">{f.icon}</div>
                            <p>{f.text}</p>
                          </div>
                        ))}
                      </div>

                      <p className="description">
                        {isExpanded
                          ? `Meet Evercore Advanced Collagen Peptides — crafted with 8g Japanese Marine Collagen Type I & III, paired with Vitamin C, Vitamin E, Glutathione, Grape Seed Extract, Hyaluronic Acid and Biotin for inside-out support 

      This thoughtful blend helps support smoother-looking skin, natural radiance and everyday repair from within.
It also helps support stronger hair, resilient nails and comfortable joints — for beauty and movement together.
Light, refreshing and gently tangy, our Blueberry Glow flavour makes wellness feel like a daily ritual.
No hype, no shortcuts — just science-led nutrition you can stay consistent with.
Rebuild. Recover. Radiate — at your own pace.`
                          : `Meet Evercore Advanced Collagen Peptides — crafted with 8g Japanese Marine Collagen Type I & III, paired with Vitamin C, Vitamin E, Glutathione, Grape Seed Extract, Hyaluronic Acid and Biotin for inside-out support. `}

                        <span
                          className="read-more"
                          onClick={() => setIsExpanded(!isExpanded)}
                        >
                          {isExpanded ? ' Read less' : ' Read more'}
                        </span>
                      </p>

                      <div className="logo-row">
                        <img
                          src="/assets/images/Frame_1.svg"
                          alt="certification"
                          className="cert-logo"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <!-- Product Left Sidebar End --> */}

      <section
        class="use-section"
        style={{ marginTop: '50px' }}
      >
        <div class="container">
          <h2 class="use-heading">Five Ways to Use It</h2>

          <div class="use-grid">
            <div class="use-card">
              <i class="fa-solid fa-dumbbell use-icon"></i>
              <h3>Post-Workout (1-2 scoops)</h3>
              <p>
                Mix immediately after training for rapid amino acid delivery, muscle support, and
                faster recovery.
              </p>
            </div>

            <div class="use-card">
              <i class="fa-solid fa-mug-hot use-icon"></i>
              <h3>Breakfast Protein Boost</h3>
              <p>
                Add to oats, coffee, or smoothies for a filling, clean-tasting morning protein
                source.
              </p>
            </div>

            <div class="use-card">
              <i class="fa-solid fa-cookie-bite use-icon"></i>
              <h3>Between-Meals Snack</h3>
              <p>
                Have 1 scoop with almond milk or water to prevent hunger and support muscle
                maintenance.
              </p>
            </div>

            <div class="use-card">
              <i class="fa-solid fa-moon use-icon"></i>
              <h3>Pre-Bed Recovery</h3>
              <p>Take before sleep for slow amino acid release and overnight recovery support.</p>
            </div>

            <div class="use-card">
              <i class="fa-solid fa-blender use-icon"></i>
              <h3>High-Protein Recipes</h3>
              <p>
                Blend into pancakes, brownies, smoothies & more for delicious high-protein meals.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="yp-protein-section">
        <div className="yp-protein-container">
          {/* Image Space */}
          <div className="yp-protein-image">
            <img
              src="/assets/images/Collagen.png"
              alt="Collagen Peptides"
            />
          </div>
          {/* Content */}
          <div className="yp-protein-content">
            <h2 className="yp-protein-headline">
              FROM WORKOUT TO GLOW-UP
              <p>Recovery, radiance and wellness — all in one daily ritual.</p>
            </h2>

            <div className="yp-benefits-grid">
              <div className="yp-benefit-item">
                <strong>Advanced Marine Collagen (Type I & III)</strong>
                <p>Supports skin structure, hair strength and nail health from within.</p>
              </div>

              <div className="yp-benefit-item">
                <strong>8g Hydrolysed Collagen Peptides</strong>
                <p>Light, easy and perfect for daily consistency.</p>
              </div>

              <div className="yp-benefit-item">
                <strong>With Vitamin C + Antioxidants</strong>
                <p>
                  Formulated to support natural collagen synthesis and protect against everyday
                  oxidative stress.
                </p>
              </div>

              <div className="yp-benefit-item">
                <strong>Hyaluronic Acid + Biotin</strong>
                <p>Nourishment for smoother-looking skin and healthier hair appearance.</p>
              </div>

              <div className="yp-benefit-item">
                <strong>No Added Sugar — Blueberry Glow Flavour</strong>
                <p>Refreshing taste. No heaviness.</p>
              </div>
            </div>
            <p style={{ marginTop: '20px' }}>Science-Led • Beauty-Focused • Daily Wellness</p>
          </div>
        </div>
      </section>

      <section className="after-core-image">
        <div className="container">
          <div className="image-wrapper">
            <img
              src="/assets/images/comaprison-banner.webp"
              alt="Core Visual"
              loading="lazy"
            />
          </div>
        </div>
      </section>

      <section className="core-with">
        <div className="container">
          <h2 className="title">The Core Within</h2>
          <div className="ingredient-grid">
            {ingredients.map((item, index) => (
              <div
                key={index}
                className="ingredient-card"
              >
                <div className="image-wrapper">
                  <img
                    src={item.img}
                    alt={item.name}
                  />
                </div>
                <div className="content">
                  <h4 className="name">
                    {item.name} <br />
                    <span className="sub">{item.subtext}</span>
                  </h4>
                  <p className="desc">{item.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* <!-- The Core Within Section Ends --> */}

      <section className="after-core-image">
        <div className="container">
          <div className="image-wrapper">
            <img
              src="/assets/images/collagen_poster.webp"
              alt="Core Visual"
              loading="lazy"
            />
          </div>
        </div>
      </section>

      <section className="flavours-new">
        <div className="container">
          <h2 className="flavours-main-title">
            <span>delicious flavours</span>, one goal
          </h2>

          <div className="flavours-center">
            {/* Card 1 */}
            <div className="flavour-card-lg active">
              <img
                src="/assets/images/Collagen.png"
                alt="Blueberry"
              />
              <p>Blue Berry</p>
            </div>
          </div>
        </div>
      </section>

      <div>
        <section className="collapsible-section">
          <div className="container">
            {/* Nutritional Information */}
            <div className={`accordion-item ${activeIndex === 0 ? 'active' : ''}`}>
              <button
                className="accordion-header"
                onClick={() => toggleAccordion(0)}
              >
                <span>Nutritional information</span>
                <span className="icon">{activeIndex === 0 ? '−' : '+'}</span>
              </button>

              <div className="accordion-content">
                {/* Nutrition Table */}
                <div className="nutrition-table">
                  <h4>Nutritional Information (Approx.)</h4>

                  <p className="serving">
                    Serving Size: 1 Leveled Scoop (10g) | Total Servings: 30
                  </p>

                  <table>
                    <thead>
                      <tr>
                        <th>Nutrients</th>
                        <th>Amt. Per Serving</th>
                        <th>%RDA</th>
                      </tr>
                    </thead>

                    <tbody>
                      <tr>
                        <td>Energy</td>
                        <td>29.68 kcal</td>
                        <td>1.48%</td>
                      </tr>
                      <tr>
                        <td>Protein</td>
                        <td>7 g</td>
                        <td>13.0%</td>
                      </tr>
                      <tr>
                        <td>Carbohydrate</td>
                        <td>0.42 g</td>
                        <td>**</td>
                      </tr>
                      <tr>
                        <td>Total Sugar</td>
                        <td>0.00 g</td>
                        <td>**</td>
                      </tr>
                      <tr>
                        <td>Added Sugar</td>
                        <td>0 g</td>
                        <td>0%</td>
                      </tr>
                      <tr>
                        <td>Total Fat</td>
                        <td>0 g</td>
                        <td>0%</td>
                      </tr>

                      {/* INGREDIENTS SECTION */}
                      <tr className="section-header">
                        <td colSpan="3">INGREDIENTS</td>
                      </tr>

                      <tr>
                        <td>Marine Collagen Peptides</td>
                        <td>8000 mg</td>
                        <td>**</td>
                      </tr>
                      <tr>
                        <td>L-Glutathione</td>
                        <td>250 mg</td>
                        <td>**</td>
                      </tr>
                      <tr>
                        <td>Vitamin C</td>
                        <td>80 mg</td>
                        <td>100%</td>
                      </tr>
                      <tr>
                        <td>Vitamin E</td>
                        <td>10 mg</td>
                        <td>100%</td>
                      </tr>
                      <tr>
                        <td>Zinc</td>
                        <td>17 mg</td>
                        <td>100%</td>
                      </tr>
                      <tr>
                        <td>Grape Seed Extract</td>
                        <td>20 mg</td>
                        <td>**</td>
                      </tr>
                      <tr>
                        <td>Biotin</td>
                        <td>40 mcg</td>
                        <td>100%</td>
                      </tr>
                      <tr>
                        <td>Selenium</td>
                        <td>40 mcg</td>
                        <td>100%</td>
                      </tr>
                      <tr>
                        <td>Hyaluronic Acid</td>
                        <td>150 mg</td>
                        <td>**</td>
                      </tr>
                    </tbody>
                  </table>

                  <small>
                    *%RDA values established as per ICMR 2020 guidelines for Men Sedentary Work.{' '}
                    <br />
                    **%RDA values not established.
                  </small>
                </div>
              </div>
            </div>

            <div className={`accordion-item ${activeIndex === 1 ? 'active' : ''}`}>
              <button
                className="accordion-header"
                onClick={() => toggleAccordion(1)}
              >
                <span>Ingredients</span>
                <span className="icon">{activeIndex === 1 ? '−' : '+'}</span>
              </button>

              <div className="accordion-content">
                <div className="ingredients-content">
                  <ul>
                    <li>- Blueberry Glow</li>
                    <li>
                      - Hydrolyesd Marine Collagen Peptide, L-Ascorbic Acid, D-Alpha Tocopheryl
                      Acetate, Zinc Gluconate, Grape Seed Extract. D-Biotin, Soudium Selenite,
                      L-Glutathione, Hyaluronic Acid, Sodium Chloride, Acidity Regulator (INS 330),
                      Monk Fruit Juice Concentrate, Nature Identical Flavouring Substnaces -
                      Blueberry Flavour, Anticaking Agent (INS 551), Permitted Food Color (INS 133).
                    </li>
                    <li>- No added sugar</li> <br />
                    <li>- Monk fruit sweetened</li> <br />
                    <li>- Gluten-free</li> <br />
                    <li>- Dairy-free</li> <br />
                    <li>- Soy-free</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className={`accordion-item ${activeIndex === 2 ? 'active' : ''}`}>
              <button
                className="accordion-header"
                onClick={() => toggleAccordion(2)}
              >
                <span> Why Choose Advance Collagen Peptides ? </span>
                <span className="icon">{activeIndex === 2 ? '−' : '+'}</span>
              </button>

              <div className="accordion-content">
                <div className="ingredients-content">
                  <p>
                    Our flavoured blend delivers 8g of Hydrolysed Japanese Marine Collagen (Type I &
                    III) paired with antioxidant support from Vitamin C, Vitamin E, Grape Seed
                    Extract, Glutathione and Selenium — working together to help defend against
                    everyday oxidative stress while supporting smoother-looking skin, joint comfort,
                    recovery and a natural glow. A smart, dual-action formula that brings beauty and
                    wellness together in one simple daily ritual — from the inside out.
                  </p>
                </div>
              </div>
            </div>

            <div className={`accordion-item ${activeIndex === 3 ? 'active' : ''}`}>
              <button
                className="accordion-header"
                onClick={() => toggleAccordion(3)}
              >
                <span>When to use advanced collagen peptides ? </span>
                <span className="icon">{activeIndex === 3 ? '−' : '+'}</span>
              </button>

              <div className="accordion-content">
                <div className="ingredients-content">
                  <p>
                    Collagen levels naturally start declining as you move through your 20s — which
                    is why supporting your body early makes such a difference. Evercore Advanced
                    Collagen Peptides delivers highly bioavailable, hydrolysed Japanese Marine
                    Collagen designed to support skin elasticity, joint comfort and stronger hair
                    and nails. Think of it as a simple daily boost that works alongside your
                    skincare and lifestyle — helping you feel supported, nourished and confident
                    from the inside out. And yes, it’s genuinely enjoyable to drink — smooth, clean
                    and refreshing, without the fishy aftertaste most collagens leave behind.
                    Available in our signature Blueberry Glow flavor.
                  </p>
                </div>
              </div>
            </div>

            <div className={`accordion-item ${activeIndex === 4 ? 'active' : ''}`}>
              <button
                className="accordion-header"
                onClick={() => toggleAccordion(4)}
              >
                <span>Myths about collagen </span>
                <span className="icon">{activeIndex === 4 ? '−' : '+'}</span>
              </button>

              <div className="accordion-content">
                <div className="ingredients-content">
                  <div className="card-content">
                    <p style={{ textAlign: 'center', fontSize: '14px' }}>
                      <strong>“Your body can’t absorb collagen”</strong>
                    </p>
                    <p style={{ textAlign: 'justify' }}>
                      {' '}
                      Fact: Hydrolysed collagen is broken down into smaller peptides, which the body
                      can use as building blocks. These peptides help support your body’s natural
                      collagen processes when taken consistently.
                    </p>
                  </div>

                  <div className="card-content">
                    <p style={{ textAlign: 'center', fontSize: '14px' }}>
                      <strong>“Collagen doesn’t really do anything.”</strong>
                    </p>
                    <p style={{ textAlign: 'justify' }}>
                      {' '}
                      Fact: Research shows collagen supplementation can help support skin
                      elasticity, hydration, joint comfort and overall tissue health when combined
                      with a balanced lifestyle. It’s not magic — it’s consistent nourishment.
                    </p>
                  </div>

                  <div className="card-content">
                    <p style={{ textAlign: 'center', fontSize: '14px' }}>
                      <strong>“You can get real collagen from plants.”</strong>
                    </p>
                    <p style={{ textAlign: 'justify' }}>
                      {' '}
                      Fact: Plants don’t contain collagen. “Plant collagen” usually means nutrients
                      that support collagen production. True collagen comes from animal sources —
                      like marine collagen — which provides actual collagen peptides.
                    </p>
                  </div>

                  <div className="card-content">
                    <p style={{ textAlign: 'center', fontSize: '14px' }}>
                      <strong>“Collagen is only for older people.”</strong>
                    </p>
                    <p style={{ textAlign: 'justify' }}>
                      {' '}
                      Fact: Natural collagen levels begin declining after your 20s. Adding collagen
                      can help support skin firmness, joint comfort and hair & nail strength —
                      whether you’re 25 or 55.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      <section className="evercore-standard">
        <div className="container-fluid-lg">
          <div className="standard-container">
            <span className="standard-eyebrow">THE EVERCORE STANDARD</span>
            <h2>Our Commitment to Quality & Purity</h2>

            <div className="standard-items">
              <div className="standard-item">
                <Icon icon="mdi:leaf" />
                <span>Monk Fruit Sweetened</span>
              </div>

              <div className="standard-item">
                <Icon icon="mdi:flask-outline" />
                <span>Science-Led Formulation</span>
              </div>

              <div className="standard-item">
                <Icon icon="mdi:stomach" />
                <span>Easy on Digestion</span>
              </div>

              <div className="standard-item">
                <Icon icon="mdi:earth" />
                <span>Globally Sourced Ingredients</span>
              </div>

              <div className="standard-item">
                <Icon icon="mdi:water-off" />
                <span>Preservative Free</span>
              </div>

              <div className="standard-item">
                <Icon icon="mdi:run" />
                <span>Lifestyle Friendly</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="certification-section">
        <div className="container-fluid-lg">
          <div className="title mb-4">
            <h2>Certifications</h2>
            <span className="title-leaf">
              <svg className="icon-width">
                <use href="../assets/svg/leaf.svg#leaf"></use>
              </svg>
            </span>
          </div>

       <div className="new-slider-wrapper">
            <div className="new-slider-slider">
              {[...certifications, ...certifications].map((item, index) => (
                <div className="cert-item" key={index}>
                  <a href="/Shop" className="cert-card">
                    <img src={item.img} alt={item.alt} />
                  </a>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <div>
        {/* REVIEWS SECTION */}
        <div
          className="reviews-container"
          style={{ marginTop: '50px' }}
        >
          <div className="reviews-header">
            <h2>Reviews</h2>
            <button
              className="write-review-btn"
              onClick={() => setShowForm(true)}
            >
              Write a Review
            </button>
          </div>

          {/* Existing review mapping logic */}
          {reviews.map((review) => (
            <div
              key={review.id}
              className="review-card"
            >
              <div className="stars">
                {Array.from({ length: totalStars }).map((_, i) => (
                  <span
                    key={i}
                    style={{ color: '#FFD700' }}
                  >
                    {i < review.rating ? '★' : '☆'}
                  </span>
                ))}
              </div>
              <p className="comment">
                {expanded === review.id ? review.comment : `${review.comment.slice(0, 120)}...`}
                {review.comment.length > 120 && (
                  <button
                    style={{ border: 'none' }}
                    onClick={() => setExpanded(expanded === review.id ? null : review.id)}
                  >
                    {expanded === review.id ? ' Show less' : ' Show more'}
                  </button>
                )}
              </p>
              <p className="time">{review.timeAgo}</p>
            </div>
          ))}
        </div>

        {/* --- THE MODAL (FIXED) --- */}
        {showForm && (
          <div className="popup-modal">
            <h3>Write a Review</h3>

            <textarea
              placeholder="How was your experience with Evercore Collagen?"
              value={reviewText}
              onChange={(e) => setReviewText(e.target.value)}
            />

            <div className="rating-input">
              <p>Your Rating:</p>
              {Array.from({ length: 5 }).map((_, i) => (
                <span
                  key={i}
                  onClick={() => setRating(i + 1)}
                >
                  {i < rating ? '★' : '☆'}
                </span>
              ))}
            </div>

            <div className="modal-actions">
              <button
                className="cancel"
                onClick={() => setShowForm(false)}
              >
                Cancel
              </button>
              <button
                className="submit"
                onClick={handleSubmitReview}
                disabled={!reviewText || rating === 0}
              >
                Submit Review
              </button>
            </div>
          </div>
        )}
      </div>

      <div>
        <section className="collapsible-section">
          {/* Lab Reports */}
          <div className="container">
            <div className={`accordion-item ${activeMain === 0 ? 'active' : ''}`}>
              <button
                className="accordion-header"
                onClick={() => toggleMain(0)}
                aria-expanded={activeMain === 0}
              >
                <span>Lab Reports</span>
                <span className="icon">{activeMain === 0 ? '−' : '+'}</span>
              </button>
              <div className="accordion-content">
                <p>Content here...</p>
              </div>
            </div>
          </div>

          {/* Know More */}
          <div className="container">
            <div className={`accordion-item ${activeMain === 1 ? 'active' : ''}`}>
              <button
                className="accordion-header"
                onClick={() => toggleMain(1)}
                aria-expanded={activeMain === 1}
              >
                <span>Know More</span>
                <span className="icon">{activeMain === 1 ? '−' : '+'}</span>
              </button>

              <div className="accordion-content">
                <p>Crafted for people who care about real wellness — inside and out</p>

                <p>
                  Created for those who value clean formulas, honest nutrition and long-term skin
                  health, Evercore Advanced Collagen Peptides brings you premium Japanese Marine
                  Collagen paired with supportive nutrients for glowing skin, stronger hair, joint
                  comfort and everyday resilience. Designed to work with your body — not against it
                  — it helps support your natural collagen processes from within, so you feel
                  nourished, supported and confident over time. This isn’t just another beauty
                  supplement — it’s a thoughtfully designed daily ritual for skin, joints and
                  overall wellness, made to fit effortlessly into your lifestyle.
                </p>

                <p>
                  <strong>What makes Evercore Collagen special?</strong>
                </p>

                <p>
                  ✨ <strong>8g Japanese Marine Collagen (Type I & III)</strong>
                </p>
                <p>
                  ✨ <strong>Vitamin C, E, Grape Seed, Glutathione & Selenium</strong>
                </p>
                <p>
                  ✨ <strong>Hyaluronic Acid</strong>
                </p>
                <p>
                  ✨ <strong>Biotin</strong>
                </p>

                <p>
                  <strong>💧 Clean & thoughtful</strong>
                  <br />
                  No added sugar • Monk fruit sweetened • Gluten-free • Soy-free • Dairy-free
                </p>
              </div>
            </div>
          </div>

          {/* FAQS */}
          <div className="container">
            <div className={`accordion-item ${activeMain === 20 ? 'active' : ''}`}>
              <button
                className="accordion-header"
                onClick={() => toggleMain(20)}
                aria-expanded={activeMain === 20}
              >
                <span>FAQs</span>
                <span className="icon">{activeMain === 20 ? '−' : '+'}</span>
              </button>
              {activeMain === 20 && (
                <div className="accordion-content scrollable">
                  {/* Question 1 */}
                  <div className="faq-expanded">
                    <div className={`accordion-item ${openIndex === 23 ? 'active' : ''}`}>
                      <button
                        className="accordion-header"
                        onClick={() => toggleFaq(23)}
                        aria-expanded={openIndex === 23}
                      >
                        <span>
                          {' '}
                          What is vegan collagen and why is it important for skin health?
                        </span>
                        <span className="icon">{openIndex === 23 ? '−' : '+'}</span>
                      </button>

                      {openIndex === 23 && (
                        <div className="accordion-content">
                          <p>Content here...</p>
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Question 2 */}
                  <div className="faq-expanded">
                    <div className={`accordion-item ${openIndex === 11 ? 'active' : ''}`}>
                      <button
                        className="accordion-header"
                        onClick={() => toggleFaq(11)}
                        aria-expanded={openIndex === 11}
                      >
                        <span> what are benefits of taking vegan collagen daily?</span>
                        <span className="icon">{openIndex === 11 ? '−' : '+'}</span>
                      </button>

                      {openIndex === 11 && (
                        <div className="accordion-content">
                          <p>Content here...</p>
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Question 3 */}
                  <div className="faq-expanded">
                    <div className={`accordion-item ${openIndex === 18 ? 'active' : ''}`}>
                      <button
                        className="accordion-header"
                        onClick={() => toggleFaq(18)}
                        aria-expanded={openIndex === 18}
                      >
                        <span> Can vegan collagen reduce wrinkless and fine lines ?</span>
                        <span className="icon">{openIndex === 18 ? '−' : '+'}</span>
                      </button>

                      {openIndex === 18 && (
                        <div className="accordion-content">
                          <p>Content here...</p>
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Question  4*/}
                  <div className="faq-expanded">
                    <div className={`accordion-item ${openIndex === 15 ? 'active' : ''}`}>
                      <button
                        className="accordion-header"
                        onClick={() => toggleFaq(15)}
                        aria-expanded={openIndex === 15}
                      >
                        <span>Can I take vegan while pregnant ?</span>
                        <span className="icon">{openIndex === 15 ? '−' : '+'}</span>
                      </button>

                      {openIndex === 15 && (
                        <div className="accordion-content">
                          <p>Content here...</p>
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Read more content */}
                  <div
                    className="read-more-container  "
                    style={{ textAlign: 'justify' }}
                  >
                    {!isExpanded && (
                      <p
                        className="read-more"
                        onClick={() => setIsExpanded(true)}
                        style={{ color: 'blue', cursor: 'pointer' }}
                      >
                        Read more
                      </p>
                    )}

                    {isExpanded && (
                      <div className="faq-expanded ">
                        {faqs.map((faq, index) => (
                          <div
                            key={index}
                            className={`accordion-item ${openIndex === index ? 'active' : ''}`}
                          >
                            <button
                              className="accordion-header"
                              onClick={() => toggleFaq(index)}
                              aria-expanded={openIndex === index}
                            >
                              <span>{faq.question}</span>
                              <span className="icon">{openIndex === index ? '−' : '+'}</span>
                            </button>

                            {openIndex === index && (
                              <div className="accordion-content">
                                <p>{faq.answer}</p>
                              </div>
                            )}
                          </div>
                        ))}

                        <p
                          className="read-more"
                          onClick={() => {
                            setIsExpanded(false);
                            setOpenIndex(null);
                          }}
                          style={{ color: 'blue', cursor: 'pointer' }}
                        >
                          Read less
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* Additional Information */}
          <div className="container">
            <div className={`accordion-item ${activeMain === 7 ? 'active' : ''}`}>
              <button
                className="accordion-header"
                onClick={() => toggleMain(7)}
                aria-expanded={activeMain === 7}
              >
                <span>Additional Information</span>
                <span className="icon">{activeMain === 7 ? '−' : '+'}</span>
              </button>

              <div className="accordion-content">
                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                  <tbody>
                    {Object.entries(productData || {}).map(([key, value]) => (
                      <tr key={key}>
                        <td style={{ fontWeight: 'bold', padding: '10px' }}>{key}</td>
                        <td style={{ padding: '10px' }}>{value}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </section>
      </div>

      {/* <!-- Sticky Cart Box Start --> */}
      <div className="sticky-bottom-cart">
        <div className="container-fluid-lg">
          <div className="row">
            <div className="col-12">
              <div className="cart-content">
                <div className="product-image">
                  <img
                    src="/assets/images/Collagen.png"
                    className="img-fluid blur-up lazyload"
                    alt="img"
                  />

                  <div className="content">
                    <h5>Evercore Collagen Peptides - Blueberry</h5>
                    <div style={{ display: 'flex', marginTop: '10px' }}>
                      <h5 className="price">
                        <span className="gradintback">
                          <span>₹699</span> <del style={{ color: '#6b6a66' }}>₹799</del>
                        </span>
                      </h5>
                      <span
                        style={{
                          margin: '0 10px',
                          padding: '6px',
                          background: '#ff4f4f1a',
                          color: '#ff4f4f',
                          borderRadius: '7px',
                        }}
                      >
                        55% off
                      </span>
                    </div>
                  </div>
                </div>

                <div className="selection-section">
                  <div className="form-group mb-0">
                    <select
                      id="input-state"
                      className="form-control form-select"
                    >
                      <option
                        selected
                        disabled
                      >
                        Choose Weight...
                      </option>
                      <option>300 g</option>
                    </select>
                  </div>
                </div>

                <div className="add-btn d-flex">
                  <div className="cart_qty qty-box product-qty m-0">
                    <div className="input-group h-100">
                      <button
                        type="button"
                        className="qty-left-minus"
                        data-type="minus"
                        data-field=""
                      >
                        <i className="fa fa-minus"></i>
                      </button>
                      <input
                        className="form-control input-number qty-input"
                        type="text"
                        name="quantity"
                        value="1"
                      />
                      <button
                        type="button"
                        className="qty-right-plus"
                        data-type="plus"
                        data-field=""
                      >
                        <i className="fa fa-plus"></i>
                      </button>
                    </div>
                  </div>
                  <a
                    className="btn pro-acc-logout-btn text-white"
                    href="/Checkout"
                  >
                    <i className="fas fa-shopping-cart"></i> Buy Now
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <!-- Related Product Section Start --> */}
      <section className="product-list-section section-b-space">
        <div className="container-fluid-lg">
          <div className="title">
            <h2>Recently Viewed</h2>
          </div>
          <div className="row">
            <div className="col-12">
              <div
                className="slider-6_1 product-wrapper"
                style={{ display: 'flex', flexDirection: 'column' }}
              >
                <div>
                  <div className="product-box-3 wow fadeInUp">
                    <div className="product-header">
                      <div className="combo-image">
                        <a href="/Productdetails">
                          <img
                            src="/assets/images/Collagen.png"
                            className="img-fluid blur-up lazyload"
                            alt="img"
                          />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <!-- Related Product Section End --> */}
      <Footer />
    </>
  );
};

export default Collagen;
